declare const KR: KRType;

type KRErrorType = { errorCode: string, errorMessage: string, field: string, children: KRErrorType[] };
type KROnErrorType = (err: KRErrorType) => void;
type KROnFormReadyType = () => void;

type KRType = {
    onError(fn: KROnErrorType): void,
    onFormReady(fn: KROnFormReadyType): void,
};

type PaymentFormType = {
    $form: HTMLFormElement|null,
    $choices: NodeListOf<HTMLInputElement>|null,
    $pvidAcceptanceField: HTMLInputElement|null,
    $acceptanceField: HTMLInputElement|null,
    $submitButton: HTMLButtonElement|null,
    init(): void,
    getKrError(_this: PaymentFormType, err: KRErrorType): string|null,
    disableSubmitButtonIfSelectedBCOrCBPaymentMethod($choice: HTMLInputElement): void,
};

const PaymentForm: PaymentFormType = {
    $form: null,
    $choices: null,
    $pvidAcceptanceField: null,
    $acceptanceField: null,
    $submitButton: null,

    init(): void {
        this.$form = document.querySelector<HTMLFormElement>('.js-payment-form');
        
        if (!this.$form) {
            return;
        }

        this.$choices = this.$form.querySelectorAll<HTMLInputElement>('.js-payment-choice');
        this.$pvidAcceptanceField = this.$form.querySelector<HTMLInputElement>('.js-payment-pvid-acceptance');
        this.$acceptanceField = this.$form.querySelector<HTMLInputElement>('.js-payment-acceptance');
        this.$submitButton = this.$form.querySelector<HTMLButtonElement>('.js-submit-button');

        this.$choices.forEach($choice => {
            this.disableSubmitButtonIfSelectedBCOrCBPaymentMethod($choice);
            $choice.addEventListener('change', () => this.disableSubmitButtonIfSelectedBCOrCBPaymentMethod($choice));
        });

        if (typeof KR !== 'undefined') {
            const _this = this;

            KR.onError(err => {
                if (0 === err.children.length) {
                    err.errorMessage = _this.getKrError(_this, err) ?? err.errorMessage;
                } else if (typeof err.children[0] !== 'undefined') {
                    err.errorMessage = _this.getKrError(_this, err.children[0]) ?? err.errorMessage;
                }
            });

            KR.onFormReady(() => {
                const $krPvidAcceptanceField = _this.$form?.querySelector<HTMLInputElement>('.js-kr-form-pvid-acceptance');
                const $krAcceptanceField = _this.$form?.querySelector<HTMLInputElement>('.js-kr-form-acceptance');

                function onAcceptanceChange() {
                    if ($krPvidAcceptanceField) {
                        if (_this.$pvidAcceptanceField?.checked) {
                            $krPvidAcceptanceField.setAttribute('value', '1');
                        } else {
                            $krPvidAcceptanceField.removeAttribute('value');
                        }
                    }

                    if ($krAcceptanceField) {
                        if (_this.$acceptanceField?.checked) {
                            $krAcceptanceField.setAttribute('value', '1');
                        } else {
                            $krAcceptanceField.removeAttribute('value');
                        }
                    }
                }

                onAcceptanceChange();
                _this.$acceptanceField?.addEventListener('change', onAcceptanceChange);
                _this.$pvidAcceptanceField?.addEventListener('change', onAcceptanceChange);
            });
        }
    },

    getKrError(_this: PaymentFormType, err: KRErrorType): string|null {
        if ('CLIENT_304' !== err.errorCode) {
            return null;
        }

        if (err.field === 'kr-form-pvid-acceptance') {
            return _this.$pvidAcceptanceField?.getAttribute('data-error-message') as string;
        } else if (err.field === 'kr-form-acceptance') {
            return _this.$acceptanceField?.getAttribute('data-error-message') as string;
        }

        return null;
    },

    /**
     * Disable the submit button if the payment method selected is BC
     * 
     * @param {HTMLInputElement} $choice
     * 
     * @return {void}
     */
    disableSubmitButtonIfSelectedBCOrCBPaymentMethod($choice: HTMLInputElement): void {
        if ($choice.checked && ['BC', 'CB'].includes($choice.value)) {
            this.$submitButton?.setAttribute('disabled', 'disabled');
        } else {
            this.$submitButton?.removeAttribute('disabled');
        }
    },
};

export default PaymentForm;
